module.exports = __webpack_public_path__ + "img/icon-menu.e04c99b0.svg";